<template>
  <div class="appeal">
    <div class="appeal__value appeal__value-header">
      <div class="appeal__header">
        <div class="appeal__property">Организация: <span
          class="appeal__span">{{ `(ID: ${item.org.id}) ${item.org.name}` }}</span>
        </div>
        <div class="appeal__property">
          ID: <span class="appeal__span">{{ item.id }}</span>
        </div>
        <div class="appeal__property">Дата создания апелляции: <span
          class="appeal__span">{{ getCreationDate }}</span>
        </div>
      </div>
    </div>
    <div class="appeal__value">
      <div>{{ item.form5KeyId }}</div>
      <div>{{ appealsNumber }}</div>
      <v-btn
        class="white__v-btn"
        @click="openAboutAppeal">
        Подробная информация
      </v-btn>
    </div>
    <div class="appeal__value appeal__status appeal__value-status">
      <div>Статус: <span class="appeal__span" :class="status.style">{{ status.text }}</span></div>
      <div v-if="getReasonDate"><span class="appeal__dateReason">{{ getReasonDate }}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardFormFiveAppeal',
  props: {
    item: {
      type: Object,
    }
  },
  computed: {
    getCreationDate() {
      if (this.item.date) {
        return this.item.date
      } else {
        return '-'
      }
    },
    getReasonDate() {
      if (this.item.dateReason) {
        return this.item.dateReason
      } else {
        return ''
      }
    },
    appealsNumber() {
      if (this.item.data?.length) {
        return `Количество апелляций по столбцу: ${this.item.data.length}`
      } else if (this.item.indicator === 'generalValue') {
        return `Апелляции по сводной оценке`
      } else {
        return `Апелляции по индикатору ${this.item.indicator}`
      }
    },
    status() {
      const elementsActive = this.item.data?.filter(el => el.accept === null);
      const elementsAgreed = this.item.data?.filter(el => el.accept === true);
      const elementsDecline = this.item.data?.filter(el => el.accept === false);
      const notFullyConsidered = this.item.data?.find(el => el.accept === null);
      const lengthData = this.item.data?.length;
      if (elementsActive?.length === lengthData)
        return {
          text: 'На рассмотрении',
          style: 'appeal_not-set'
        }
      else if (elementsAgreed?.length === lengthData)
        return {
          text: 'Удовлетворена',
          style: 'appeal_accepted'
        }
      else if (elementsDecline?.length === lengthData) {
        return {
          text: 'Отказано',
          style: 'appeal_rejected'
        }
      } else if (notFullyConsidered) {
        return {
          text: 'Есть нерассмотренные',
          style: 'appeal_not-fully-considered'
        }
      } else {
        return {
          text: 'Частично принята',
          style: 'appeal_rejected'
        }
      }
    },
  },
  methods: {
    openAboutAppeal() {
      this.$emit('openAboutAppeal', this.item);
    }
  }
}
</script>

<style lang="scss" scoped>
.appeal {
  background: #fff;
  margin-bottom: 15px;
  padding: 7px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-left: 3px solid #00599b;
  transition: 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 18px rgba(14, 21, 47, 0.1), 0 -2px 6px rgba(14, 21, 47, 0.02);
    transition: 0.3s;
  }
}

.appeal__value {
  flex-basis: 0;
  flex-grow: 1;
  padding: 0 10px;
}

.appeal__value-header {
  flex-basis: 100px;
}

.appeal__value-status {
  flex-basis: 50px;
}

.appeal__header {
  display: flex;
  flex-direction: column;
  flex-basis: 300px;
}

.appeal__property {
  margin-bottom: 5px;
}

.appeal__span {
  background: #E3EFFA;
  padding: 2px 5px;
  border-radius: 7px;
  flex-grow: 1;
  color: #00599B;
  line-height: 18.75px;
  height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
}

.appeal_accepted {
  background: #EBF9EB;
  border: 1px solid #8FE28E;
  color: #29A128;
}

.appeal_rejected {
  background: #FDEBEB;
  border: 1px solid #F89B9B;
  color: #ED393E;
}

.appeal_not-fully-considered {
  background: #ffe0be;
  border: 1px solid #ffab33;
  color: #ffab00;
}
</style>